// extracted by mini-css-extract-plugin
export default {"cls1":"iNWDKjqEchx8d_2b9u3H","cls2":"u1Jqnpw5XWKC0YLkS3P7 iNWDKjqEchx8d_2b9u3H"};